import PropTypes from "prop-types"
import { Skeleton } from "@mui/material"

export default function SkeletonSection({ rowCount = 3, colCount = 3 }) {
  return (
    <div className="renderers_compare-section skeleton-section">
      <div className="body">
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
          <div key={rowIndex}>
            <div />
            <div>
              <Skeleton variant="text" width="100%" height={20} />
            </div>
            {Array.from({ length: colCount }).map((_, colIndex) => (
              <div key={colIndex}>
                <Skeleton variant="text" width="100%" height={20} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

SkeletonSection.propTypes = {
  rowCount: PropTypes.number,
  colCount: PropTypes.number,
}
